import { Transaction } from "../../../types/transaction";
import {
    TransactionDto,
    TransactionDtoInput,
} from "../../transactions/transaction.dto";

export interface BothModifiedConflict {
    transactionFromDestination: Transaction;
    transactionFromMerged: Transaction;
}

export class BothModifiedConflictDto {
    transactionFromDestination: TransactionDto;
    transactionFromMerged: TransactionDto;

    constructor(conflict: BothModifiedConflict) {
        this.transactionFromDestination = new TransactionDto(
            conflict.transactionFromDestination as TransactionDtoInput,
        );
        this.transactionFromMerged = new TransactionDto(
            conflict.transactionFromMerged as TransactionDtoInput,
        );
    }

    static deserialize(dto: BothModifiedConflictDto): BothModifiedConflict {
        return {
            transactionFromDestination: TransactionDto.deserialize(
                dto.transactionFromDestination,
            ) as Transaction,
            transactionFromMerged: TransactionDto.deserialize(
                dto.transactionFromMerged,
            ) as Transaction,
        };
    }
}
